import { validate } from "../../utils/validate"
import { toast } from "../../share/ui/toast/index.web"
import { Overlay } from "../../share/ui/overlay/overlay.web"

// let useAddDlgFn: null | ((dlgList: React.ReactChild[]) => void) = null

const overlay = new Overlay()

/**
 * @dtsModule max.ui
 * @dtsNamespace ui
 * @dtsDesc ui UI
 */
export const ui = {
  /**
   * 初始化函数
   */
  init(cfg?: { dialog?: (dlgList: React.ReactNode[]) => void }) {
    // useAddDlgFn = useAddDlg
  },
  /**
   * @dtsExport
   * Display the toast prompt globally
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.ui.toast&lang=%{locale}%)
   */
  toast(content: string, duration: "long" | "short" = "short") {
    validate.String(content, "content")
    if (duration && duration !== "long" && duration !== "short") {
      throw Error(`duration must be "long" or "short"`)
    }
    toast(content, duration)
  },

  loading(config?: {
    showListener?: () => void
    dismissListener?: () => void
    isCancelable?: boolean
  }) {
    return {
      show: () => { },
      hide: () => { }
    }
  },
  /**
   * @dtsExport
   * Display floating layer
   */
  showOverlay(data: any): void {
    overlay.showOverlay(data)
  },
  /**
   * @dtsExport
   * Hilde floating layer
   */
  hideOverlay(): void {
    overlay.hideOverlay()
  }
}
